import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
import styles from './styles.module.sass';

const mapStateToProps = (state) => ({
  user: state.user
});

@connect(mapStateToProps)
class Header extends PureComponent {
  render() {
    return (
      <div className={cx('Header', styles.component)}>
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/layout/Header/Header.jsx